<!-- <h1 style="text-align: center">Upload</h1> -->
<div class="upload-asset-div"
    *ngIf="httpService.folder && httpService.folder._id">
    <sh-text class="font-super-header display-inline-box">

        <sh-text class="upload-asset-text"
            *ngIf=" httpService.folder?.name && !httpService.updateAssetFile && !httpService.newVersionFlag && !httpService.newExtensionFlag"
             class="font-super-header">Upload Asset in {{
            httpService.folder?.name }}</sh-text>

        <sh-text *ngIf="httpService.updateAssetFile" class="font-super-header">Update {{asset.name}}</sh-text>
        <sh-text *ngIf="httpService.newExtensionFlag" class="font-super-header">Add new extension to
            {{asset.name}}</sh-text>
        <sh-text *ngIf="httpService.newVersionFlag" class="font-super-header">Add new version in
            {{asset.name}}</sh-text>
    </sh-text>

    <div class="upload-back-btn">
        <sh-grid>
            <sh-button columns="7" class="margin-left-auto" color='secondary' label='Back' (click)="cancel()"
                id="bcancel"></sh-button>
            <sh-button columns="4" class="margin-left-auto" label='Upload' [disabled]="uploadEnable"
                (click)="upload()" id="bupload">
            </sh-button>
            <sh-icon icon='information' id="target-1" *ngIf="uploadEnable"></sh-icon>
            <sh-tooltip label="Upload will be enabled only when a 3D asset or texture file is added. If only updating the images, click Back after update." target="target-1" placement="left" title="Upload disabled" *ngIf="uploadEnable"></sh-tooltip>
        </sh-grid>
    </div>
</div>

<!-- <hr> -->
<div class="uploadCenter">
    <div class="asset-grid">
        <input type="file" (change)="onFileSelected($event)" (click)="onInputClick($event)" name="file" id="file"
            multiple="true" hidden #input>
        <!-- Showing a alert to user not to upload any coyrighted/proprietary assets to VAL-->
        <sh-modal id="modify-alert" type='alert' label='Warning' modal-height='auto' modal-width='400px' visible sticky>
            Proprietary/copyrighted assets should not be uploaded to VAL.
            <sh-button color='tertiary' slot='footer' label='Cancel' (click)="cancelUploadProcess()"></sh-button>
            <sh-button color='primary' slot='footer' label='Ok'
                onclick="document.querySelector('#modify-alert').visible = false"></sh-button>
        </sh-modal>
        <div class="margin-auto" label='Enter Assets Informaion'>

            <sh-input-text label='Asset Name*'
                *ngIf="!httpService.newVersionFlag && !httpService.newExtensionFlag && !httpService.updateAssetFile"
                [value]="asset.name" (value-changed)="asset.name=$event.target.value" id="tinewAssetName"
                (blur)="assetNameExists = assetNameControl.invalid && (!httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile) ? false : assetNameCheck(asset.name)"
                [formControl]="assetNameControl" ngDefaultControl name="tinewAssetName" [value]="asset.name"
                [error]="(assetNameControl.touched || isUploadClicked) && (assetNameExists || assetNameControl.invalid)">
            </sh-input-text>
            <sh-tooltip *ngIf="assetNameControl.touched && assetNameControl.hasError('required')"
                label="Please enter the Asset Name" target="tinewAssetName" placement="bottom-right" variation="short">
            </sh-tooltip>
            <sh-tooltip *ngIf="assetNameExists" class="asset-name-exists-tooltip"
                label="The entered asset name already exists. Please enter a different Asset Name"
                target="tinewAssetName" placement="bottom-right" variation="short"></sh-tooltip>
            <sh-tooltip *ngIf="assetNameControl.touched && assetNameControl.hasError('pattern')"
                title="Rules for asset name:"
                label="Cannot start/end with '-' and '_'. Any other special characters are not allowed."
                target="tinewAssetName" placement="bottom-right"></sh-tooltip>

            <sh-input-text label='Asset Name*' disabled
                *ngIf="httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile"
                [value]="asset.name" id="tinewAssetName" name="tinewAssetName"></sh-input-text>
            <br>
            <sh-checkbox label='Are you the Primary Contact?'
                [active]="!httpService.newVersionFlag && !httpService.newExtensionFlag && !httpService.updateAssetFile"
                (click)="togglePCDiv($event)"
                [disabled]="httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile">
            </sh-checkbox>
            <sh-grid clasprimary-contact-grid *ngIf="showPrimaryContactDiv">
                <div columns="6" col-m="6" col-s="12">
                    <sh-input-text id="primaryContactName"
                        *ngIf="!httpService.newVersionFlag && !httpService.newExtensionFlag && !httpService.updateAssetFile"
                        label='Primary Contact Name*' [value]="asset.attributes.primaryContact.name"
                        (value-changed)="asset.attributes.primaryContact.name=$event.target.value"
                        name="primaryContactName" ngDefaultControl
                        [error]="(primaryContactNameControl.touched || isUploadClicked) && primaryContactNameControl.invalid"
                        [formControl]="primaryContactNameControl"></sh-input-text>

                    <sh-tooltip class="padding-top-0"
                        *ngIf="primaryContactNameControl.touched && primaryContactNameControl.touched && primaryContactNameControl.invalid"
                        label="Please enter the Primary Contact Name" target="primaryContactName"
                        placement="bottom-right" variation="short"></sh-tooltip>

                    <sh-input-text id="primaryContactName" disabled
                        *ngIf="httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile"
                        label='Primary Contact Name*' [value]="asset.attributes.primaryContact.name" id="pcName">
                    </sh-input-text>
                </div>
                <div columns="6" col-m="6" col-s="12">
                    <sh-input-text id="primaryContactEmail"
                        *ngIf="!httpService.newVersionFlag && !httpService.newExtensionFlag && !httpService.updateAssetFile"
                        label='Primary Contact Email Address*' [value]="asset.attributes.primaryContact.emailId"
                        (value-changed)="asset.attributes.primaryContact.emailId=$event.target.value"
                        name="primaryContactEmail" ngDefaultControl
                        [error]="(primaryContactEmailControl.touched || isUploadClicked) && primaryContactEmailControl.invalid"
                        id="pcEmail" [formControl]="primaryContactEmailControl"></sh-input-text>
                    <sh-tooltip class="padding-top-0"
                        *ngIf="primaryContactEmailControl.touched && primaryContactEmailControl.hasError('required')"
                        label="Please enter the Primary Contact Email Id" target="pcEmail"
                        placement="bottom-right" variation="short"></sh-tooltip>
                    <sh-tooltip class="padding-top-0"
                        *ngIf="primaryContactEmailControl.touched && (primaryContactEmailControl.hasError('pattern') || primaryContactEmailControl.hasError('email'))"
                        label="Please enter a valid Primary Contact Email Id" target="pcEmail"
                        placement="bottom-right" variation="short"></sh-tooltip>

                    <sh-input-text id="primaryContactEmail" disabled
                        *ngIf="httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile"
                        label='Primary Contact Email Address*' [value]="asset.attributes.primaryContact.emailId"
                        id="pcEmail"></sh-input-text>
                </div>
            </sh-grid>
            <br>
            <sh-divider></sh-divider>
            <br>
            <div>
                <sh-radio-group>
                    <sh-text>Product Status</sh-text>
                    <sh-radio-button
                        [disabled]="httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile"
                        label="Not Commercially Ready" id="productstatus1"
                        [active]="asset.attributes?.productStatus === 0" active
                        (click)="asset.attributes.productStatus = 0"></sh-radio-button>
                    <sh-radio-button disabled class="pointer-events-none" label="Commercially Ready"
                        [active]="asset.attributes?.productStatus === 1" (click)="asset.attributes.productStatus = 1"></sh-radio-button>
                </sh-radio-group>
            </div>
            <br>
            <sh-divider></sh-divider>

            <div>
                <sh-radio-group>
                    <sh-text>Asset Accesibility</sh-text>
                    <sh-radio-button
                        [disabled]="httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile"
                        label="Private" id="productstatus1" [active]="asset.attributes?.visibility === 0" active
                        (click)="asset.attributes.visibility = 0"></sh-radio-button>
                    <sh-radio-button disabled class="pointer-events-none" label="Public" [active]="asset.attributes?.visibility === 1"
                        (click)="asset.attributes.visibility = 1"></sh-radio-button>
                </sh-radio-group>
            </div>
            <br>
            <sh-divider></sh-divider>

            <br>
            <div>
                <div class="overflow-hidden" label='Specifications' expanded>
                    <sh-text class="asset-spec-text">Assets Specifications</sh-text>
                    <div class="assetDetailsGrid">
                        <sh-checkbox label='Rigged' id="cbspecificationrigged" [active]="assetFileSpecifaction.rigged"
                            (click)="changeCheckBoxValue(assetFileSpecifaction,'rigged')"></sh-checkbox>
                        <sh-tooltip class="tooltip"
                            label="In its simplest form, 3D rigging is the process of creating a skeleton for a 3D model so it can move. Especially characters, complex robots (e.g. C-Arms) and medical tables need to be rigged to use them adequately in a 3D animated environment."
                            target="cbspecificationrigged" placement="bottom" title='Rigged'></sh-tooltip>
                        <sh-checkbox label='Animation' id="cbspecificationanimation"
                            [active]="assetFileSpecifaction.animation"
                            (click)="changeCheckBoxValue(assetFileSpecifaction,'animation')"></sh-checkbox>
                        <sh-tooltip class="tooltip"
                            label="Animated 3D objects have attributes added for certain predefined movements. There is no need to add any animation clips at this point (only to better visualize the way the object is animated). Animations for 3D objects shall be used for predefined movements which do not have a certain logic (in code) attached to is. This allows developers to select predefined animation paths for better visualization without a larger user input."
                            target="cbspecificationanimation" placement="bottom" title='Animation'>
                        </sh-tooltip>
                        <!-- <sh-checkbox label='Spin' [active]="assetFileSpecifaction.spin" id="cbspecificationspin" (click)="changeCheckBoxValue(assetFileSpecifaction,'spin')"></sh-checkbox> -->
                        <sh-checkbox label='Movement Logic' [active]="assetFileSpecifaction.movementLogic"
                            id="cbspecificationmovement"
                            (click)="changeCheckBoxValue(assetFileSpecifaction,'movementLogic')" disabled></sh-checkbox>
                        <sh-tooltip class="tooltip" target="cbspecificationmovement" placement="bottom-right"
                            variation="short"
                            label="Movement Logic : The Movement Logic is the preparation for an interactive object. With a script there is a logical component added to the “rigged and animated” 3D object. This allows a user to access certain standard movement behaviors of the 3D objects. (e.g. the logic of a Kuka-Robot movement according to the individual arms)">
                        </sh-tooltip>
                        <!-- <sh-checkbox label='Interaction' [active]="assetFileSpecifaction.interaction" id="cbspecificationinteraction" (click)="changeCheckBoxValue(assetFileSpecifaction,'interaction')"></sh-checkbox> -->
                        <sh-checkbox label='User Interaction' [active]="assetFileSpecifaction.userInteraction"
                            id="cbspecificationuserInteraction"
                            (click)="changeCheckBoxValue(assetFileSpecifaction,'userInteraction')" disabled>
                        </sh-checkbox>
                        <sh-tooltip target="cbspecificationuserInteraction" placement="bottom-right" variation="short"
                            label="User Interaction : The User Interaction is the combination of a “rigged and animated” 3D-object that has a script attached to it which enables the user to interact with the object with the use of a certain input method (e.g. controller, haptic devices, eyetracking, …). This feature requires the a versioned asset which is stored in the GIT structure.">
                        </sh-tooltip>
                        <!-- <sh-checkbox label='Joystick Interaction' [active]="assetFileSpecifaction.joystickInteraction" id="cbspecificationjoystick" (click)="changeCheckBoxValue(assetFileSpecifaction,'joystickInteraction')"></sh-checkbox> -->
                        <sh-checkbox label='Update Via Git' disabled
                            [active]="assetFileSpecifaction.automaticallyUpdateViaGit" id="cbspecificationupdatedviagit"
                            (click)="changeCheckBoxValue(assetFileSpecifaction,'automaticallyUpdateViaGit')">
                        </sh-checkbox>
                    </div>
                </div>
                <br>
                <sh-divider></sh-divider>
                <br>
                <div>
                    <sh-input-text label='Tags for Asset' id="tiassetTags"
                        [disabled]="httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile"
                        (keyup.enter)="addTags($event.target.value.trim());$event.target.value = ''"
                        (keyup.,)="addTags($event.target.value.split(',')[0].trim()); $event.target.value = ''"
                        (blur)="validateTagName($event.target.value.trim())" maxlength="19" [error]="assetTagError">
                    </sh-input-text>
                    <sh-tooltip *ngIf="assetTagError" title="Rules for tag names:"
                        label="Cannot start/end with '-'. Can end with '+'. Cannot start with '++' and '#'. Cannot end with '.'. Any other special characters are not allowed."
                        target="tiassetTags" placement="bottom-right"></sh-tooltip>
                </div>
                <br>
                <div class="tags">
                    <div *ngFor="let tag of asset.tags; let i = index" class="tags-div">
                        {{tag}}
                        <sh-icon button icon="error" class="error-btn"
                            *ngIf="!httpService.newVersionFlag && !httpService.newExtensionFlag && !httpService.updateAssetFile"
                            (click)="removeTag(i)">
                        </sh-icon>
                    </div>
                </div>

            </div>

            <!-- <div>
            <sh-card label='3D Files'>
                <h1>Hi</h1>
            </sh-card>
        </div> -->
        </div>

        <!-- <br>
        <sh-divider></sh-divider>
        <br>

        <div>
            <p>Preview Images</p>
            <img *ngFor="let url of selectedPreviewImages" style="margin-right: 8px;" [src]="url" height="80px">
        </div> -->
    </div>

    <div class="upload-area">
        <ngx-file-drop id="dropFilesBox" dropZoneLabel="Drop Files Here" dropZoneClassName="dropZone {{theme_color}}"
            (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)">
            <!-- <span>optional content (don't set headertext then)</span> -->
        </ngx-file-drop>
        <sh-tooltip *ngIf="noFilerError" label="Please upload atleast one 3D file" target="dropFilesBox"
            placement="bottom-right" variation="short"></sh-tooltip>
        <sh-button color='primary' id="browseBtn" label='Browse' (click)="input.click()" class="browse">
        </sh-button>
    </div>

    <div class="upload-area2">
        <sh-text>Preview Images</sh-text>
        <div class="upload-area2-div">
            <div *ngFor="let url of selectedPreviewImages" class="imgStyle">
                <img class="preview-image" [src]="url" height="100px">
                <sh-icon icon="cancel" (click)="setupDelete(url)" class="overlay"></sh-icon>
            </div>
            <div *ngIf="selectedPreviewImages.length < 10">
                <sh-icon class="add-preview-image-icon" icon="plus" size="l" (click)="setupAdd()"></sh-icon>
            </div>
        </div>
    </div>

    <div class="threeD">
        <div label='3D Files'>
            <sh-card label="3D File" class="files threed-card" card-height="400px">
                <sh-dropdown class="threed-dropdown" id="dropdownthreedfile" *ngIf="threeDfile?.relativePath"
                    label='Quality' [value]=fileQuality (value-changed)="fileQuality=$event.target.value">
                    <sh-menu-item id="3h" label='High' active (click)="fileQuality = 'High'"></sh-menu-item>
                    <sh-menu-item id="3m" label='Medium' (click)="fileQuality = 'Medium'"></sh-menu-item>
                    <sh-menu-item id="3l" label='Low' (click)="fileQuality = 'Low'"></sh-menu-item>
                </sh-dropdown>
                <sh-dropdown class="threed-dropdown" id="dropdownthreedfile" *ngIf="threeDfile?.webkitRelativePath === ''"
                    label='Quality' [value]=fileQuality (value-changed)="fileQuality=$event.target.value">
                    <sh-menu-item id="3h" label='High' active (click)="fileQuality = 'High'"></sh-menu-item>
                    <sh-menu-item id="3m" label='Medium' (click)="fileQuality = 'Medium'"></sh-menu-item>
                    <sh-menu-item id="3l" label='Low' (click)="fileQuality = 'Low'"></sh-menu-item>
                </sh-dropdown>
                <strong class="relative-path-pos" *ngIf="threeDfile?.relativePath">{{ threeDfile?.relativePath }}
                    <sh-icon class="error-icon" button icon="error"
                        (click)="deleteThreeDFile(threeDfile)"></sh-icon></strong>
                <strong class="relative-path-pos" *ngIf="threeDfile?.webkitRelativePath === ''">{{ threeDfile?.name }}
                    <sh-icon class="error-icon" button icon="error"
                        (click)="deleteThreeDFile(threeDfile)"></sh-icon></strong>
            </sh-card>
        </div>
    </div>
    <div class="texture">
        <div label='Texture Files'>
            <sh-card class="texture-card" label='Texture Files' card-height="400px">
                <sh-dropdown class="texture-dropdown" id="dropdowntextture" *ngIf="threeDfile?.relativePath || texturesFiles.length > 0"
                    label='Quality' [value]=texturequality
                    (value-changed)="texturequality=$event.target.value">
                    <sh-menu-item id="h" label='High' active (click)="texturequality = 'High'"></sh-menu-item>
                    <sh-menu-item id="m" label='Medium' (click)="texturequality = 'Medium'"></sh-menu-item>
                    <sh-menu-item id="l" label='Low' (click)="texturequality = 'Low'"></sh-menu-item>
                </sh-dropdown>
                <strong class="relative-path-pos" *ngFor="let item of texturesFiles; let i=index">
                    <sh-text *ngIf="item?.relativePath?.split('.').slice(-1) != 'zip'">{{ item.relativePath }}
                        <sh-icon class="error-icon"
                            button icon="error" *ngIf="item.relativePath"
                            (click)="deleteFile(item, texturesFiles)"></sh-icon>
                    </sh-text>
                    <sh-text *ngIf="item.webkitRelativePath === ''">{{ item.name }}
                        <sh-icon class="error-icon" button icon="error"
                            (click)="deleteFile(item, texturesFiles)"></sh-icon>
                    </sh-text>
                </strong>
            </sh-card>
        </div>
    </div>
</div>

<div id="overlay" *ngIf="loader">
    <div class="loader">
        <sh-progress-radial size="l" value="{{uploadPercentDone}}" label="{{uploadPercentDone}}%" info='Uploading'>
        </sh-progress-radial>
        <b class="warning">{{ uploadWarningText }}</b>
        <!-- <sh-spinner label="Uploading"></sh-spinner> -->
    </div>
</div>

<sh-modal id="unsupported" type='alert' label='Unsupported Files' modal-height='184px' modal-width='320px'>
    <sh-text p>Unsupported format(s): {{unsupportedFiles[0] ? unsupportedFiles[0].name: unsupportedFiles}}</sh-text>
    <!-- any component can close the modal by removing the 'visible' attribute -->
    <sh-button color='tertiary' slot='footer' label='Close'
        onclick="document.getElementById('unsupported').removeAttribute('visible')"></sh-button>
    <!-- <sh-button color='secondary' slot='footer' label='Delete'></sh-button> -->
</sh-modal>

<sh-modal id="alreadyPresent" type='alert' label='File present' modal-height='184px' modal-width='320px'>
    <sh-text p>An asset file with this configuration is already present in the current version</sh-text>
    <!-- any component can close the modal by removing the 'visible' attribute -->
    <sh-button color='tertiary' slot='footer' label='Close'
        onclick="document.getElementById('alreadyPresent').removeAttribute('visible')"></sh-button>
    <!-- <sh-button color='secondary' slot='footer' label='Delete'></sh-button> -->
</sh-modal>

<sh-modal id="imageToDelete" type='alert' label='Confirmation' modal-height='60vh' modal-width='60vh'>
    <sh-text p>Are you sure you want to delete this image?</sh-text>
    <br>
    <sh-text p>{{deletePath}}</sh-text>
    <!-- any component can close the modal by removing the 'visible' attribute -->
    <img class="delete-img" [src]="deleteImg">
    <sh-button color='tertiary' slot='footer' label='Close'
        onclick="document.getElementById('imageToDelete').removeAttribute('visible')"></sh-button>
    <sh-button color='secondary' slot='footer' label='Delete'
        onclick="document.getElementById('imageToDelete').removeAttribute('visible')" (click)="deleteImage()">
    </sh-button>
</sh-modal>

<sh-modal id="imageToAdd" type='info' label='Confirmation' modal-height='40vh' modal-width='60vh'>
    <sh-text p>Upload an image</sh-text>
    <br>
    <input class="upload-img-input" type="file" multiple id="browseFile" #browseFile (change)="selectPreviewImage($event)">
    <sh-button class="browse-btn" shape="pill-m" label="Browse Image" for="browseFile" id="browseImage" (click)="openBrowseWindow()">
    </sh-button>
    <!-- any component can close the modal by removing the 'visible' attribute -->
    <!-- <img [src]="deleteImg" style="object-fit: contain;width: 100%;"> -->

    <div *ngFor="let img of preview">
        <sh-text p>{{img.file.name}}</sh-text>
        <img class="preview-image" [src]="img.src" height="100px">
    </div>

    <sh-button color='tertiary' slot='footer' label='Close'
        onclick="document.getElementById('imageToAdd').removeAttribute('visible')" (click)="clearImgSelection()">
    </sh-button>
    <sh-button color='secondary' slot='footer' label='Upload'
        onclick="document.getElementById('imageToAdd').removeAttribute('visible')" (click)="addImage()"
        [disabled]="previewImage.length===0"></sh-button>
</sh-modal>

<sh-modal id="unsupported-image" type='alert' label='Unsupported Image' modal-height='184px' modal-width='320px'>
    <sh-text p>{{unsupportedImageErrorMessage}}
    </sh-text>
    <sh-button color='tertiary' slot='footer' label='Close'
        onclick="document.getElementById('unsupported-image').removeAttribute('visible')"></sh-button>
</sh-modal>